var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_840_2453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0.5H4C1.79086 0.5 0 2.29086 0 4.5V16.5C0 18.7091 1.79086 20.5 4 20.5H16C18.2091 20.5 20 18.7091 20 16.5V4.5C20 2.29086 18.2091 0.5 16 0.5Z",
    fill: "#0516C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 8.625H10.75V7.125C10.75 6.711 11.086 6.375 11.5 6.375H12.25V4.5H10.75C9.50725 4.5 8.5 5.50725 8.5 6.75V8.625H7V10.5H8.5V16.5H10.75V10.5H12.25L13 8.625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_840_2453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.56d68f93e07cabf7f508a4978e208aef.svg";
export { ForwardRef as ReactComponent };